import { BaseModel } from "../base-model";
import { ItemStateModel } from "../base-itemstate";
import { IBaseTranslation } from "../base-translation";

export interface IPropertyDocumentModel extends ItemStateModel {
  PropertyId?: number;
  IsFolder?: boolean;
  GroupId?: number;
  Comments?: string;
  Filename?: string;
  DocumentTypeId?: number;
  PublishOnInternetId?: number;
  IsIncludeInMail?: boolean;
  IsConvertToPDF?: boolean;
  LanguageId?: number;
  PreviewFileName?: string;
  DocumentTypeInfo?: IBaseTranslation;
  PublishOnInternetInfo?: IBaseTranslation;
  ItemState?: number;
  FilePath?: string;
  IsGroup?: boolean;
  URL?: string;
  IconURL?: string;
	EditUrl?: string;
  EditType?: DocumentEditType;
  IsMissingOnCloud?: boolean;
  SignTags?: Array<string>;
}
export class PropertyDocumentModel extends BaseModel<IPropertyDocumentModel>
  implements IPropertyDocumentModel {
  get IsGroup(): boolean {
    return !(this.DocumentTypeId > 0);
  }

  Id?: number;
  PropertyId: number;
  IsFolder: boolean;
  GroupId: number;
  Comments: string;
  Filename: string;
  DocumentTypeId: number;
  PublishOnInternetId: number;
  IsIncludeInMail: boolean;
  IsConvertToPDF: boolean;
  LanguageId: number;
  PreviewFileName: string;
  DocumentTypeInfo: IBaseTranslation;
  PublishOnInternetInfo: IBaseTranslation;
  FilePath: string;
  ItemState: number;
  URL: string;
  IconURL?: string;
	EditUrl?: string;
  EditType?: DocumentEditType;
  IsMissingOnCloud?: boolean;
  SignTags?: Array<string>;
  /**
   *
   */
  constructor(option?: IPropertyDocumentModel) {
    super(option);
  }
}

export class PropertyDocumentUpdateModel {
  Id: number;
  Field: string;
  Value: object;
}

export class MoveGroupModel {
  fromId: number;
  toId: number;
}

export enum DocumentEditType {
  Word = 1,
  Excel = 2,
  PowerPoint = 3,
}
